import {Injectable} from '@angular/core';
import {SclCsvParserService} from './scl-csv-parser.service';

const sclCsvParser = new SclCsvParserService();

@Injectable({
  providedIn: 'root'
})
export class SclCsvParserHandlerService {

  constructor() {
  }

  ParserHandle(_CONFIG) {
    const Baby = sclCsvParser.getBaby();

    // One goal is to minimize the use of regular expressions...
    const FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;

    const self = this;
    let stepCounter = 0;	// Number of times step was called (number of rows parsed)
    let _INPUT = null;				// The input being parsed
    let parser = null;			// The core parser being used
    let paused = false;	// Whether we are paused or not
    let delimiterError = false;	// Temporary state between delimiter detection and processing results
    const fields = [];		// Fields are from the header row of the input, if there is one
    let _RESULTS = {		// The last results returned from the parser
      data: [],
      errors: [],
      meta: {
        fields: undefined,
        delimiter: undefined
      }
    };


    const isFunction = (func) => {
      return typeof func === 'function';
    };

    const copy = (obj) => {
      if (typeof obj !== 'object') {
        return obj;
      }
      const cpy = obj instanceof Array ? [] : {};
      for (const key in obj) {
        if (obj[key]) {
          cpy[key] = copy(obj[key]);
        }
      }
      return cpy;
    };

    if (isFunction(_CONFIG.step)) {
      const userStep = _CONFIG.step;
      _CONFIG.step = (results) => {
        _RESULTS = results;

        if (needsHeaderRow()) {
          processResults();
        } else {
          processResults();

          // It's possbile that this line was empty and there's no row here after all
          if (_RESULTS.data.length === 0) {
            return;
          }

          stepCounter += results.data.length;
          if (_CONFIG.preview && stepCounter > _CONFIG.preview) {
            parser.abort();
          } else {
            userStep(_RESULTS, self);
          }
        }
      };
    }

    function parse(input) {
      if (!_CONFIG.newline) {
        _CONFIG.newline = guessLineEndings(input);
      }

      delimiterError = false;
      if (!_CONFIG.delimiter) {
        const delimGuess = guessDelimiter(input);
        if (delimGuess.successful) {
          _CONFIG.delimiter = delimGuess.bestDelimiter;
        } else {
          delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
          // @ts-ignore
          _CONFIG.delimiter = Baby.DefaultDelimiter;
        }
        _RESULTS.meta.delimiter = _CONFIG.delimiter;
      }

      const parserConfig = copy(_CONFIG);
      if (_CONFIG.preview && _CONFIG.header) {
        parserConfig.preview++;
      }	// to compensate for header row

      _INPUT = input;
      parser = new sclCsvParser.Parser(parserConfig);
      _RESULTS = parser.parse(_INPUT);
      processResults();
      // @ts-ignore
      if (isFunction(_CONFIG.complete) && !paused && (!self.streamer || self.streamer.finished())) {
        _CONFIG.complete(_RESULTS);
      }
      return paused ? {meta: {paused: true}} : (_RESULTS || {meta: {paused: false}});
    }

    function pause() {
      paused = true;
      parser.abort();
      _INPUT = _INPUT.substr(parser.getCharIndex());
    }

    function resume() {
      paused = false;
      parser = new sclCsvParser.Parser(_CONFIG);
      parser.parse(_INPUT);
      if (!paused) {
        // @ts-ignore
        if (self.streamer && !self.streamer.finished()) {
          // @ts-ignore
          self.streamer.resume();
        } else if (isFunction(_CONFIG.complete)) {
          _CONFIG.complete(_RESULTS);
        }
      }
    }

    function abort() {
      parser.abort();
      if (isFunction(_CONFIG.complete)) {
        _CONFIG.complete(_RESULTS);
      }
      _INPUT = '';
    }

    function processResults() {
      if (_RESULTS && delimiterError) {
        // tslint:disable-next-line:max-line-length
        addError('Delimiter', 'UndetectableDelimiter', 'Unable to auto-detect delimiting character; defaulted to \'' + Baby.DefaultDelimiter + '\'');
        delimiterError = false;
      }

      if (_CONFIG.skipEmptyLines) {
        for (let i = 0; i < _RESULTS.data.length; i++) {
          if (_RESULTS.data[i].length === 1 && _RESULTS.data[i][0] === '') {
            _RESULTS.data.splice(i--, 1);
          }
        }
      }

      if (needsHeaderRow()) {
        fillHeaderFields();
      }

      return applyHeaderAndDynamicTyping();
    }

    function needsHeaderRow() {
      return _CONFIG.header && fields.length === 0;
    }

    function fillHeaderFields() {
      if (!_RESULTS) {
        return;
      }
      for (let i = 0; needsHeaderRow() && i < _RESULTS.data.length; i++) {
        for (let j = 0; j < _RESULTS.data[i].length; j++) {
          fields.push(_RESULTS.data[i][j]);
        }
      }
      _RESULTS.data.splice(0, 1);
    }

    function applyHeaderAndDynamicTyping() {
      if (!_RESULTS || (!_CONFIG.header && !_CONFIG.dynamicTyping)) {
        return _RESULTS;
      }

      for (let i = 0; i < _RESULTS.data.length; i++) {
        const row = {};

        for (let j = 0; j < _RESULTS.data[i].length; j++) {
          if (_CONFIG.dynamicTyping) {
            const value = _RESULTS.data[i][j];
            if (value === 'true' || value === 'TRUE') {
              _RESULTS.data[i][j] = true;
            } else if (value === 'false' || value === 'FALSE') {
              _RESULTS.data[i][j] = false;
            } else {
              _RESULTS.data[i][j] = tryParseFloat(value);
            }
          }

          if (_CONFIG.header) {
            if (j >= fields.length) {
              // @ts-ignore
              if (!row.__parsed_extra) {
                // @ts-ignore
                row.__parsed_extra = [];
              }
              // @ts-ignore
              row.__parsed_extra.push(_RESULTS.data[i][j]);
            } else {
              row[fields[j]] = _RESULTS.data[i][j];
            }
          }
          if (_CONFIG.header) {
            _RESULTS.data[i] = row;
            if (j > fields.length) {
              addError('FieldMismatch', 'TooManyFields', 'Too many fields: expected ' + fields.length + ' fields but parsed ' + j, i);
            } else if (j < fields.length) {
              addError('FieldMismatch', 'TooFewFields', 'Too few fields: expected ' + fields.length + ' fields but parsed ' + j, i);
            }
          }
        }
      }

      if (_CONFIG.header && _RESULTS.meta) {
        _RESULTS.meta.fields = fields;
      }
      return _RESULTS;
    }

    function guessDelimiter(input) {
      const delimChoices = [',', '\t', '|', ';', Baby.RECORD_SEP, Baby.UNIT_SEP];
      let bestDelim;
      let bestDelta;
      let fieldCountPrevRow;

      for (let i = 0; i < delimChoices.length; i++) {
        const delim = delimChoices[i];
        let delta = 0;
        let avgFieldCount = 0;
        fieldCountPrevRow = undefined;

        const preview = new sclCsvParser.Parser({
          delimiter: delim,
          preview: 10
        }).parse(input);

        for (let j = 0; j < preview.data.length; j++) {
          const fieldCount = preview.data[j].length;
          avgFieldCount += fieldCount;

          if (typeof fieldCountPrevRow === 'undefined') {
            fieldCountPrevRow = fieldCount;
            continue;
          } else if (fieldCount > 1) {
            delta += Math.abs(fieldCount - fieldCountPrevRow);
            fieldCountPrevRow = fieldCount;
          }
        }

        avgFieldCount /= preview.data.length;

        if ((typeof bestDelta === 'undefined' || delta < bestDelta)
          && avgFieldCount > 1.99) {
          bestDelta = delta;
          bestDelim = delim;
        }
      }

      _CONFIG.delimiter = bestDelim;

      return {
        successful: !!bestDelim,
        bestDelimiter: bestDelim
      };
    }

    function guessLineEndings(input) {
      input = input.substr(0, 1024 * 1024);	// max length 1 MB

      const r = input.split('\r');

      if (r.length === 1) {
        return '\n';
      }

      let numWithN = 0;
      for (let i = 0; i < r.length; i++) {
        if (r[i][0] === '\n') {
          numWithN++;
        }
      }

      return numWithN >= r.length / 2 ? '\r\n' : '\r';
    }

    function tryParseFloat(val) {
      const isNumber = FLOAT.test(val);
      return isNumber ? parseFloat(val) : val;
    }

    function addError(type?, code?, msg?, row?) {
      _RESULTS.errors.push({
        type: type,
        code: code,
        message: msg,
        row: row
      });
    }
  }

}

